import React, { useState, useEffect } from "react";
import factoryIconsImg from "../assets/contact-form.png";
import styles from "./ContactPopup.module.css";

function ContactPopup({ open, onClose }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleSubmit(e) {
    e.preventDefault();

    const subject = encodeURIComponent(`Contact enquiry from ${form.name}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\nPhone: ${form.phone}\n\nMessage:\n${form.message}`
    );

    window.location.href = `mailto:info@saisenaimpex.com?subject=${subject}&body=${body}`;

    alert("Thank you for your enquiry!");
    setForm({ name: "", email: "", phone: "", message: "" });
    onClose();
  }

  useEffect(() => {
    if (open) {
      const original = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = original; };
    }
  }, [open]);

  if (!open) return null;
  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <button className={styles.close} onClick={onClose}>&times;</button>
        <div className={styles.flex}>
          <div className={styles.imgside}>
            <img
              src={factoryIconsImg}
              alt="Factory icons"
              className={styles.image}
            />
          </div>
          <div className={styles.formside}>
            <h2>Contact Us</h2>
            <form onSubmit={handleSubmit} className={styles.form}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={form.email}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={form.phone}
                onChange={handleChange}
              />
              <textarea
                name="message"
                placeholder="Your Enquiry"
                value={form.message}
                onChange={handleChange}
                required
                rows={4}
              />
              <button type="submit" className={styles.submit}>
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPopup;
